import { render, staticRenderFns } from "./OtherLoanTable.vue?vue&type=template&id=2553bc0e"
import script from "./OtherLoanTable.vue?vue&type=script&lang=js"
export * from "./OtherLoanTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports